import React, {useState} from "react"
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from "reactstrap"
//Import Star Ratings
import StarRatings from "react-star-ratings";

const ProductReview = props => {
    const { isOpen, toggle } = props

    const [starRating, setStarRating] = useState(0)

    return (
        <Modal
            isOpen={isOpen}
            role="dialog"
            autoFocus={true}
            centered={true}
            className="exampleModal"
            tabIndex="-1"
            toggle={toggle}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle}>Write Product Review</ModalHeader>
                <ModalBody>
                    <div className="text-center me-3 mb-3">
                            <StarRatings
                              rating={starRating}
                              starRatedColor="#F1B44C"
                              starEmptyColor="#74788d"
                              starHoverColor="#F1B44C"
                              numberOfStars={5}
                              name="rating"
                              starDimension="25px"
                              starSpacing="3px"
                              changeRating={rate => {setStarRating(rate)}}
                            />
                    </div>
                    <div className="mt-2">
                        <div className="position-relative">
                           <input className="input-group" id="reviewInputbox" type="textarea"></input>      
                        </div>                 
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary">Save</Button>
                    <Button type="button" color="secondary" onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </div>
        </Modal>

    )
}

// #545a6d
export default ProductReview